import React from "react";
import { motion } from "framer-motion";
import { practiceAreas } from "../../data/practices";
import { Link } from "react-router-dom";
const MotionLink = motion(Link);
export default function PracticeAreas() {
  return (
    <div className="bg-white py-16 px-6  md:px-16">
      {/* Section Title */}
      <motion.div 
        className="text-center mb-14"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="text-4xl font-extrabold text-goldenYellow uppercase tracking-wide">
          Practice Areas
        </h2>
        <p className="text-gray-600 mt-3 text-lg max-w-2xl mx-auto leading-relaxed">
          Our experienced legal team specializes in a wide range of practice areas to ensure justice and protection for our clients.
        </p>
        <div className="w-32 h-1 bg-goldenYellow mx-auto mt-4 rounded-full"></div>
      </motion.div>

      {/* Grid Layout */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
  {practiceAreas.map((area, index) => (
    <MotionLink to={`/practice/${area.link}`}
      key={index}
      className="relative group bg-white border border-gray-300 rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:bg-[#0F172A] hover:text-white"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
    >
      {/* Image */}
      <img
        src={area.image}
        alt={area.title}
        className="w-full h-64 object-cover transition-all duration-500 group-hover:opacity-40"
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-70 transition-all duration-500"></div>

      {/* Title and Description */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
        <motion.h3
          className="text-2xl font-bold text-white group-hover:text-goldenYellow transition-all duration-300"
          whileHover={{ scale: 1.1 }}
        >
          {area.title}
        </motion.h3>
        <motion.p
          className="opacity-0 group-hover:opacity-100 text-white mt-3 text-base transition-opacity duration-500"
          initial={{ y: 10 }}
          whileHover={{ y: 0 }}
        >
          {area.description}
        </motion.p>
      </div>
    </MotionLink>
  ))}
</div>

    </div>
  );
}
